export const AXES = ['product', 'accessory', 'setting', 'angle'] as const;
export type Axis = (typeof AXES)[number];

export interface Photo {
  id: number;
  path: string;
  original_path: string;
  batch: string;
  preview: string | null;
  status: 'pending' | 'classifying' | 'done' | 'error';
  product: string | null;
  accessory: string | null;
  setting: string | null;
  angle: string | null;
  proposed_name: string | null;
  seconds: number | null;
  error: string | null;
  c_product: string | null;
  c_accessory: string | null;
  c_setting: string | null;
  c_angle: string | null;
  corrected_at: string | null;
  renamed_at: string | null;
}

export interface AppConfig {
  axes: Record<Axis, string[]>;
  filename_order: Axis[];
  omit_values: Partial<Record<Axis, string>>;
  model: string;
  product_hints: Record<string, string>;
  fewshot_n: number;
  exemplars_available: number;
}

export interface Batch {
  batch: string;
  total: number;
  done: number;
  errors: number;
  corrected: number;
}

export interface Progress {
  running: boolean;
  currentId: number | null;
  currentName: string | null;
  doneThisRun: number;
  totalThisRun: number;
  lastError: string | null;
  exemplarsUsed: number;
}

export interface Stats {
  reviewed: number;
  ok_product: number | null;
  ok_accessory: number | null;
  ok_setting: number | null;
  ok_angle: number | null;
  ok_all: number | null;
}

/** Final value per axis: human correction wins over the model's answer. */
export function finalValues(p: Photo): Record<Axis, string> {
  return Object.fromEntries(
    AXES.map((a) => [a, (p[`c_${a}`] ?? p[a]) as string])
  ) as Record<Axis, string>;
}

export function assembleName(cfg: AppConfig, values: Record<Axis, string>): string {
  return cfg.filename_order
    .filter((a) => values[a] !== cfg.omit_values?.[a])
    .map((a) => values[a])
    .join(' ');
}
